"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryStack2d = void 0;
const rc_js_util_1 = require("rc-js-util");
// todo jack26: update this on entity added or removed, generally add dirty checking flags
/**
 * @public
 * Assigns a value to {@link T2dRelativeZIndexTrait} based on the position in the stack. Entities towards the top of the
 * stack have higher values.
 */
class CategoryStack2d {
    constructor(category) {
        this.category = category;
        this.entities = new rc_js_util_1.DirtyCheckedUniqueCollection();
    }
    addEntity(entity) {
        this.entities.add(entity);
    }
    update() {
        if (!this.entities.isDirty) {
            return;
        }
        const entities = this.entities.getArray();
        this.category.entityZIndexRange = entities.length;
        for (let i = 0, iEnd = entities.length; i < iEnd; ++i) {
            entities[i].graphicsSettings.zIndexRel = i;
        }
    }
}
exports.CategoryStack2d = CategoryStack2d;
//# sourceMappingURL=category-stack2d.js.map